export const cropperEmpregare = {
    validarImagemEnviada(event) {
        const fileInput = event.target;
        const files = fileInput.files;

        if (!files || files.length === 0) {
            return;
        }

        const file = files[0];
        // Mesmos formatos que o backend aceita (UploadFoto): jpg, jpeg, png e gif.
        const formatosAceitos = ['image/jpeg', 'image/png', 'image/gif'];
        const imagemValida = formatosAceitos.includes(file.type);

        if (imagemValida) {
            const imageURL = URL.createObjectURL(file);
            return { file, imageURL };
        } else {
            return null;
        }
    },
    async iniciarCropper(cancelarCallback, salvarCallback) {
        // cropperjs carregado sob demanda (chunk separado); CSS no curriculo.scss.
        const { default: Cropper } = await import(/* webpackChunkName: "cropperjs" */ 'cropperjs');

        const imagemCandidato = document.getElementById('imagem-foto-candidato');
        const cropper = new Cropper(imagemCandidato, {
            aspectRatio: 1 / 1,
            viewMode: 1,
            crop(event) {
                const jsonObj = {
                    x: event.detail.x,
                    y: event.detail.y,
                    height: event.detail.height,
                    width: event.detail.width,
                    rotate: event.detail.rotate,
                    scaleX: event.detail.scaleX,
                    scaleY: event.detail.scaleY,
                    originalWidth: imagemCandidato.naturalWidth,
                    originalHeight: imagemCandidato.naturalHeight
                }

                const json = JSON.stringify(jsonObj);

                $('.avatar-data').val(json);
            }
        })

        if (cancelarCallback)
            cancelarCallback(cropper);

        if (salvarCallback)
            salvarCallback(cropper);
    }
}

